<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'autologin',
    data () {
      return {}
    },
    computed: {
      ...mapGetters('user', [
        'isLoggedIn'
      ])
    },
    created () {
      this.providerLogin()
    },
    methods: {
      ...mapActions('user', [
        'loginByMsisdn'
      ]),
      providerLogin () {
        const provider = this.$route.params.provider

        if (provider === 'entel') {
          let providerCountry = this.$route.query.country ? this.$route.query.country : 'PER'
          localStorage.setItem('providerCountry', providerCountry)
          if (this.$route.query.msfw) {
            this.loginByMsisdn({msisdn: this.$route.query.msfw, provider: provider, enc: true}).then((e) => {
            }).catch(() => {
            })
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/provider/Autologin.vue